import Alert from '@pelckmans/elementis/components/alert';
import Button from '@pelckmans/elementis/components/button';

interface Props {
  onRetry: () => Promise<void>;
  message: string;
  ctaText: string;
}

function RetryAlert({ onRetry, message, ctaText }: Props) {
  return (
    <Alert
      prominence="danger"
      className="modal-content-space-alert-padding-b"
      actions={{
        'aria-label': undefined,
        role: undefined,
        size: 'xs',
        children: (
          <Button onClick={onRetry} prominence="danger">
            {ctaText}
          </Button>
        ),
      }}
    >
      {message}
    </Alert>
  );
}

export default RetryAlert;
